export function money(n) {
  const v = Number(n || 0);
  return v.toLocaleString("en-US", { style: "currency", currency: "USD" });
}

export function shortDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? "—"
    : d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
}

export function dateInputValue(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toISOString().slice(0, 10);
}

/** A carried credit reads as "$80.00 credit", not a bare "-$80.00". */
export function balanceLabel(n) {
  const v = Number(n || 0);
  return v < 0 ? `${money(-v)} credit` : money(v);
}

export const TYPE_LABELS = {
  ACSA_Client: "ACSA Client",
  Client: "Client",
};

export const SOURCE_LABELS = {
  QuickLog: "Quick Time Log",
  Workbench: "Workbench",
};

export const ENTRY_STATUS_TONE = {
  Approved: "success",
  Draft: "info",
  Excluded: "muted",
  Invoiced: "accent",
};
